import { IconButton, alpha, styled } from '@mui/material';

export const ContainerStyled = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  maxHeight: 'calc(100% - 64px)',
  zIndex: 2,

  [theme.breakpoints.down('sm')]: {
    '&.isGuest': {
      height: '100%',
    },
  },

  '&.connected': {
    justifyItems: 'stretch',
    alignItems: 'stretch',
    height: '100%',
  },

  '& .theater': {
    maxWidth: `calc(100% - ${theme.spacing(1)})`,
    // paddingLeft: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
  },
  [theme.breakpoints.up('sm')]: {
    maxHeight: 'calc(100% - 98px)',
    '&.listView': {
      flexDirection: 'row',
      flexGrow: 1,
      padding: theme.spacing(1),
      alignItems: 'center',
      gap: theme.spacing(2),

      '& .theater': {
        width: '100%',
        aspectRatio: '16 / 9',
        maxHeight: '100%',
      },
    },
  },
}));

export const GridContainerStyled = styled('div')(({ theme }) => ({
  '--columns': 1,
  '--rows': 1,

  position: 'relative',

  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  overflowX: 'hidden',

  gap: theme.spacing(1),
  maxWidth: '100%',
  padding: theme.spacing(1),

  [theme.breakpoints.down('sm')]: {
    '&.isGuest': {
      height: '100%',
    },
  },

  '& .grid-item': {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    transition: theme.transitions.create(['all'], {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.complex,
    }),

    '&.notConnected': {
      opacity: 0.5,
    },

    [theme.breakpoints.up('sm')]: {
      width: `calc(100% / var(--columns) - ${theme.spacing(1)})`,
      height: `calc(100% / var(--rows) - ${theme.spacing(1)})`,
      '&.theater': {
        width: '100%',
      },
    },
  },

  '&:not(.connected)': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: theme.spacing(1),
    height: 'fit-content',
    '--rows': '1 !important',
    '--columns': '2 !important',
    [theme.breakpoints.up('md')]: {
      '--columns': '4 !important',
    },
    [theme.breakpoints.up('lg')]: {
      '--columns': '6 !important',
    },
    [theme.breakpoints.up('xl')]: {
      '--columns': '8 !important',
    },

    '& .grid-item': {
      height: '100%',
      width: `calc(100% / var(--columns) - ${theme.spacing(1)})`,
      aspectRatio: '16 / 9',
    },
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'center',
    overflow: 'hidden',
    flexWrap: 'wrap',
    height: '100%',

    '&.listView': {
      padding: 0,
      justifyContent: 'flex-start',
      flexDirection: 'column',
      overflowX: 'hidden',
      overflowY: 'auto',
      flexWrap: 'nowrap',

      '--rows': '8 !important',
      '--columns': '1 !important',
      width: 200,
      minWidth: 212,

      '& .grid-item': {
        width: 200,
        minWidth: 200,
        aspectRatio: '16 / 9',
        height: 'fit-content',
      },
    },
  },
}));

export const StyledMoreUsers = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: `calc(100% / var(--columns) - ${theme.spacing(1)})`,
  },
}));

export const CollapseListButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 16,
  right: 220,
  '&.collapsed': {
    right: 0,
  },
  backgroundColor: alpha(theme.palette.ai[100], 0.48),
  borderRadius: theme.spacing(1, 0, 0, 1),
  paddingRight: 0,
}));
